import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import compose from 'helpers/compose';

import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { Autocomplete } from '@material-ui/lab';
//import { CircularProgress } from '@material-ui/core';
//import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

//import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog';
import Info from 'components/Tooltip/Info';

import { RootStore } from 'stores/rootStore';
import { EdwardColors } from 'enums';
import { ExternalProductsStore } from 'stores/workflowStores/finances/externalProducts/externalProducts';
import { FinancialInstitution } from './model';
import { searchInStrings } from 'helpers/helpers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      '& > div.MuiInputBase-root': {
        paddingRight: '8px !important',
      },
    },
    actions: {
      '& button': {
        margin: theme.spacing(0, 1),
      },
    },
  }),
);

interface Props {
  rootStore: RootStore;
  store: ExternalProductsStore;
  update: (fi: FinancialInstitution | null) => void;
  fi?: FinancialInstitution;
  errors?: string[];
}

// TODO: common search comp.?

const FinInstSearch: React.FC<Props> = ({ rootStore, store, update, fi, errors }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  //const [showSearch, setShowSearch] = useState(true);
  //const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(fi?.title || '');
  const [value, setValue] = useState<FinancialInstitution | null>(null);
  const [open, setOpen] = useState(false);
  //const [id, setId] = useState<string | null>(null);
  const [displayError, setDisplayError] = useState<string[] | undefined>(errors);

  useEffect(() => {
    (async () => {
      await store.fetchLookupOptions();
    })();
  }, [store]);

  /*
  const handleSearch = useMemo(
    () =>
      debounce(async (query: string) => {
        setLoading(true);
        await store.fetchLookupOptions(query);
        setLoading(false);
      }, 2000),
    [store],
  );
  */

  useEffect(() => {
    setDisplayError(errors);
  }, [errors]);

  return (
    <>
      <Grid item xs={12}>
        <Autocomplete
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          value={value}
          onChange={(event: any, newValue: FinancialInstitution | null) => {
            setValue(newValue);
            setSearch(newValue ? newValue.title : '');
            update(newValue);
          }}
          getOptionSelected={(option, value) => option.title === value.title}
          getOptionLabel={(option) => option.title}
          options={store.lookupOptions} //
          inputValue={search}
          loading={false}
          //filterOptions={(options: FinancialInstitution[], state: object) => options}
          filterOptions={(options: FinancialInstitution[], state: object) =>
            options.filter((o) => searchInStrings(search.trim(), [o.title]))
          }
          clearOnBlur={false}
          noOptionsText={t(search.trim().length < 3 ? 'general_noResultsTooShort' : 'general_noResults')}
          loadingText={t('general_searching')}
          renderInput={(params) => (
            <Box position="relative">
              <TextField
                {...params}
                label={t(`externalProduct_financialInstitution`)}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment:
                    search === '' ? null : (
                      <CloseIcon onClick={() => setSearch('')} />
                    ),
                  startAdornment: <SearchIcon htmlColor={EdwardColors.GRAY_LIGHTER} />,
                }}
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value);
                  /*
                const query = event.target.value.trim();
                if (query.length >= 3) {
                  setLoading(true);
                  handleSearch(query);
                } else {
                  store.clearLookupOptions();
                }
                */
                }}
                className={classes.input}
              />
              <Info content={t('externalProduct_financialInstitution_tooltip')} help />
            </Box>
          )}
        />
        {displayError && <p style={{ color: EdwardColors.ALERT }}>{displayError.map((err) => t(err))}</p>}
      </Grid>
    </>
  );
};

export default compose(inject('rootStore'), observer)(FinInstSearch);
